import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import TopNav from '../../../components/TopNav';
import './GrowBusiness.scss';

class GrowBusiness extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,
    canSeeMessageCenter: PropTypes.bool,
  };

  static defaultProps = {
    originalOrgId: null,
    orgInfo: null,
    canSeeMessageCenter: false,
  };

  render() {
    const { login, logout, auth, originalOrgId, orgInfo, newMessage, newMessageCount, canSeeMessageCenter } = this.props;

    return (
      <div className="grow-business-page">
        <Helmet>
          <title>NFFS ICON - Grow Your Business</title>
          <meta name="description" content="ICON's tailored bid matching allows users to set up customizable settings to receive daily email notifications of open solicitations that perfectly align with your foundry's materials, processes, and specialization." />
        </Helmet>

        <TopNav
          login={login}
          logout={logout}
          auth={auth}
          originalOrgId={originalOrgId}
          orgInfo={orgInfo}
          newMessage={newMessage}
          newMessageCount={newMessageCount}
          canSeeMessageCenter={canSeeMessageCenter}
        />

        <Container className="mt-4">
          <Row>
            <Col>
              <h1 className="page-title mb-4">Grow Your Business</h1>
              <div className="content-box p-4">
                <h2>ICON&apos;s Tailored Bid Matching</h2>
                <p className="lead">
                  ICON&apos;s tailored bid matching allows users to set up customizable settings within the portal to receive daily email notifications of open solicitations that perfectly align with your foundry&apos;s materials, processes, and specialization. This saves valuable time that would otherwise be spent sifting through irrelevant opportunities. By actively engaging with the features and functionalities of ICON, foundries can effectively position themselves within the defense casting market, secure new contracts, and become an approved source for future contracts with DoD.
                </p>
                <hr />
                <h3>Key Features:</h3>
                <ul>
                  <li>Customized bid match settings</li>
                  <li>Daily emails highlighting opportunities that match business strengths</li>
                  <li>Explore specific details of part requirements, design and view technical data packages (drawings)</li>
                  <li>Filter opportunities by materials, processes, dimensions, and capabilities</li>
                  <li>Access to full procurement history and estimated contract values</li>
                  <li>Direct links to technical drawings and specifications</li>
                </ul>
              </div>
            </Col>
          </Row>

        </Container>
      </div>
    );
  }
}

export default GrowBusiness;



// WEBPACK FOOTER //
// ./src/pages/static/GrowBusiness/GrowBusiness.jsx